import { render, staticRenderFns } from "./AffairHostel.vue?vue&type=template&id=8d0e391a"
import script from "./AffairHostel.vue?vue&type=script&lang=js"
export * from "./AffairHostel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports